module.exports = __webpack_public_path__ + "static/media/uploadCancelInactive.58927ccb.svg";